import { DatePicker, Input, Select } from "antd";
import { Col, Form, Row } from "antd";
import React, { FC } from "react";

type DischargeProps = {
  form: any;
  portalSubmission: any;
  isApproved: boolean;
};

const Discharge: FC<DischargeProps> = ({ form, portalSubmission, isApproved }) => {
  const dateFormat = "DD-MM-YYYY HH:mm:ss";
  return (
    <div>
      <div
        style={{
          textDecoration: "underline",
          fontSize: "16px",
          margin: "16px 0",
          fontWeight: "bold",
        }}
      >
        Discharge
      </div>
      <Form form={form} layout="vertical">
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={4} lg={4} xl={4}>
            <Form.Item
              label="Discharge Date"
              name="dateOfDischarge"
              style={{ color: "#575757" }}
              rules={[
                {
                  required: true,
                  message: "Please input Discharge Date",
                },
              ]}
            >
              <DatePicker
                placeholder="Please input Discharge Date"
                style={{ color: "black", width: "100%" }}
                format={dateFormat}
                disabled={portalSubmission}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={4} lg={4} xl={4}>
            <Form.Item label="Next Follow Up Date" name="dischargeFollowUpDate">
              <DatePicker
                placeholder="Please input Next Follow Up Date"
                style={{ color: "black", width: "100%" }}
                format={dateFormat}
                disabled={portalSubmission}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={4} lg={4} xl={4}>
            <Form.Item
              label="Consult At Block Name"
              name="dischargeConsultAtBlockName"
            >
              <Input
                placeholder="Please input Consult At Block Name"
                style={{ color: "black" }}
                disabled={portalSubmission}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={4} lg={4} xl={4}>
            <Form.Item
              label="floor"
              name="dischargeFloor"
              style={{ color: "#575757" }}
            >
              <Input
                placeholder="Please input discharge Floor"
                style={{ color: "black" }}
                disabled={portalSubmission}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={4} lg={4} xl={4}>
            <Form.Item
              label="Room No"
              name="dischargeRoomNo"
              style={{ color: "#575757" }}
            >
              <Input
                placeholder="Please input Room No"
                style={{ color: "black" }}
                disabled={portalSubmission}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={4} lg={4} xl={4}>
            <Form.Item
              label="Discharge Status"
              name="dischargeStatus"
              rules={[
                {
                  required: true,
                  message: "Please select Discharge Status",
                },
              ]}
            >
              <Select
                placeholder="Select Discharge Status"
                style={{ maxWidth: 300 }}
                disabled={portalSubmission}
              >
                {[
                  {
                    label: "YES",
                    value: "YES",
                  },
                  {
                    label: "NO",
                    value: "NO",
                  },
                ]?.map((option) => (
                  <Select.Option key={option?.value} value={option?.value}>
                    {option?.label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default Discharge;
